export default "__VITE_ASSET__1QzzB85j__"